import { showToast } from 'vant';
import Clipboard from 'clipboard';
import iconWechat from '@/assets/images/icon_wechat@2x.png';
import iconWechatMoments from '@/assets/images/icon_pengyou@2x.png';
import iconWeibo from '@/assets/images/icon_weibo@2x.png';
import iconQQ from '@/assets/images/icon_qq@2x.png';
import iconDingtalk from '@/assets/images/icon_dingtalk@2x.png';
import iconMofun from '@/assets/images/icon_mofun@2x.png';
import iconLetter from '@/assets/images/icon_letter@2x.png';
import iconLink from '@/assets/images/icon_link@2x.png';
export default {
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    sources: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  data() {
    return {
      innerShareOptions: {
        // apiList: ['Wechat', 'WechatMoments', 'SinaWeibo', 'QQ', 'DingTalk', 'Mofun', 'Letter', 'CopyUrl'],
        apiList: ['Wechat', 'WechatMoments', 'SinaWeibo', 'QQ', 'DingTalk', 'Mofun', 'CopyUrl'],
        title: '',
        titleUrl: '',
        text: '',
        url: '',
        shareType: '',
        success: () => {},
        fail: () => {},
        complete: () => {}
      }
    };
  },
  computed: {
    apiDatas() {
      return {
        Wechat: {
          icon: iconWechat,
          label: '微信'
        },
        WechatMoments: {
          icon: iconWechatMoments,
          label: '朋友圈'
        },
        SinaWeibo: {
          icon: iconWeibo,
          label: '新浪'
        },
        QQ: {
          icon: iconQQ,
          label: 'QQ'
        },
        DingTalk: {
          icon: iconDingtalk,
          label: '钉钉'
        },
        Mofun: {
          icon: iconMofun,
          label: '摩范圈'
        },
        Letter: {
          icon: iconLetter,
          label: '私信和群'
        },
        CopyUrl: {
          icon: iconLink,
          label: '链接'
        }
      };
    },
    apiList() {
      return this.innerShareOptions.apiList.map(item => ({
        name: item,
        label: this.apiDatas[item].label,
        icon: this.apiDatas[item].icon,
        id: Math.random()
      }));
    }
  },
  methods: {
    setOptions(options = {}) {
      const apiList = this.innerShareOptions.apiList;
      this.innerShareOptions = {
        ...this.innerShareOptions,
        ...JSON.parse(JSON.stringify(options)),
        success: options.success || this.success,
        fail: options.fail || this.fail
      };
      this.innerShareOptions.apiList = this.innerShareOptions.apiList.length ? this.innerShareOptions.apiList : apiList;
    },
    open(options = {}) {
      this.setOptions(options);
      this.visible = true;
      this.copyUrl();
    },
    hide() {
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
    copyUrl() {
      const titleUrl = this.innerShareOptions.titleUrl;
      this.$nextTick(() => {
        const clipboard = new Clipboard('.btn-copy-link', {
          // 绑定需要的触发的dom
          text() {
            return titleUrl;
          }
        });
        clipboard.on('success', e => {
          this.innerShareOptions.complete && this.innerShareOptions.complete(e);
          this.innerShareOptions.success && this.innerShareOptions.success(e);
          this.visible = false;
          showToast('已复制');
        });
        clipboard.on('error', e => {
          this.innerShareOptions.complete && this.innerShareOptions.complete(e);
          this.innerShareOptions.error && this.innerShareOptions.error(e);
        });
      });
    },
    openAppShare(item) {
      const {
        success
      } = this.innerShareOptions;
      // if (item.name === 'CopyUrl') {
      //   return;
      // }
      if (success) {
        success(item);
      }
      // window.cfmoto.openShare({
      //   name: item.name,
      //   title,
      //   titleUrl,
      //   text,
      //   url,
      //   shareType,
      //   imageUrl,
      //   complete: (e) => {
      //     this.visible = false;
      //     complete(e);
      //   },
      //   success,
      //   fail,
      // });
    }
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};